<template>
  <BaseView class="index-container" :class="[activeIndex === 1 ? 'index-container-supply' : 'index-container']">
    <div slot="contantView" class="content">
      <div class="index-panel">
        <div class="nav-panel">
          <HeaderView :active-index="1" />
          <img src="../assets/spsc/coreBusiness/navBg.png" class="navImg"/>
        </div>
        <section class="nav-section">
          <div class="nav-info">
            <div>
              <span class="nav-main-text" @click="goGoalPage('/')">Home</span>
              <span class="nav-arrow">></span>
              <span class="nav-sub-text" @click="goGoalPage('/coreBusiness')">{{navText}}</span>
            </div>
            <div class="business-group">
              <div class="business-item" v-for="(item, index) in businessArr" :key="item.id" @click="handleBusiness(item, index)">
                <div class="business-text">{{item.text}}</div>
                <div v-if="activeIndex === index" class="active-line"></div>
              </div>
            </div>
          </div>
          <div class="nav-line"></div>
        </section>
        <section class="content-panel">
          <div v-if="activeIndex === 99" class="business-content">
            <div class="procurement-group">
              <div class="procurement-left-part">
                <div class="business-title">
                  <div>PROJECT</div>
                  <div>PROCUREMENT &</div>
                  <div>MANAGEMENT</div>
                </div>
                <div class="moer-btn-project" @click="changeBusinessContent(0, '')">More></div>
              </div>
              <div class="procurement-right-part">
                <div class="procurement-item" v-for="procureItem in procurementArr" :key="procureItem.id">
                  <div class="circle-dot"></div>
                  <div class="procurement-text">{{procureItem.text}}</div>
                </div>
              </div>
            </div>
            <div class="supply-group">
              <div class="supply-left-part">
                <div class="business-title">
                  <div>SUPPLY-CHAIN</div>
                  <div>MANAGEMENT</div>
                </div>
                <div class="moer-btn-supply" @click="changeBusinessContent(1)">More></div>
              </div>
              <div class="supply-right-part">
                <div class="supply-item" v-for="supplyItem in supplyArr" :key="supplyItem.id">
                  <div class="supply-circle-dot"></div>
                  <div class="supply-text">{{supplyItem.text}}</div>
                </div>
              </div>
            </div>
            <div class="trading-group">
              <div class="trading-left-part">
                <div class="trading-title">
                  <div>COMMODITY</div>
                  <div>TRADING</div>
                </div>
                <div class="trading-moer-btn" @click="changeBusinessContent(2)">More></div>
              </div>
              <div class="trading-right-part">
                <div class="trading-item" v-for="tradingItem in tradingArr" :key="tradingItem.id">
                  <div class="trading-circle-dot"></div>
                  <div class="trading-text">{{tradingItem.text}}</div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="activeIndex === 0" class="business-content">
            <div class="procurement-section">
              <div class="content-title">Project Procurement</div>
              <div class="project-pic1"></div>
              <div class="project-pic-group">
                <div class="project-pic2"></div>
                <div class="project-pic3"></div>
              </div>
              <div class="project-intro">
                <div>SPSC devote to provide integrative project procurement services to customers in photovoltaic, energy, chemical, shipbuilding, offshore, mining, municipal engineering and infrastructure industries.</div>
                <div>The products include modularization structures, facility equipment, tools, raw materials such as cements, steel plate and section, precast panel, curtain wall, scaffold, ceramic tiling, sanitary, furniture, home appliancesetc.</div>
                <div>Reliable, convenient and economical procurement solution is our priority, and the E-Smart procurement platform basing on big data of market and project factors is on process. </div>
              </div>
              <div class="project-pic4"></div>
              <div class="project-pic-group1">
                <div class="project-pic5"></div>
                <div class="project-pic6"></div>
              </div>
              <div class="content-title">Project Management</div>
              <div class="management-section">
                <div class="management-group">
                  <div class="management-info">
                    <div >SP-PMS collects engineering data and construction information in one system. Project</div>
                    <div >dashboard will be custom-made based on the project principal factors and characters. The</div>
                    <div >project status can be visualized with user inquiries such as:</div>
                    <div class="management-words">
                      <div >•Project progress;</div>
                      <div >•Project resource;</div>
                      <div >•Cost control</div>
                      <div >•Engineering and QA documentation;</div>
                      <div >•Inspection Data;</div>
                      <div >•Quality control;</div>
                      <div >•Customized reports (MDR).</div>
                    </div>
                    <div > With the assistance of SP-PMS, the customer can execute the project with more efficiency by</div>
                    <div >providing real time status and progress of the project. This should provide efficiency in</div>
                    <div > performance, better quality control and potentially, less risk.</div>
                  </div>
                  <div class="project-pic7"></div>
                </div>
                <div class="management-group">
                  <div class="project-pic8"></div>
                  <div class="project-pic9"></div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="activeIndex === 1" class="business-content">
            <div class="supply-chain-section">
              <div class="chain-item" v-for="chainItem in chainArr" :key="chainItem.id">
                <div class="chain-pic">
                  <img :src="chainItem.imgUrl" class="chain-img" />
                </div>
                <div class="chain-text">{{ chainItem.text }}</div>
                <div class="chain-describe">{{ chainItem.describe }}</div>
              </div>
            </div>
          </div>
          <div v-if="activeIndex === 2" class="business-content">
            <div class="trading-section">
              <div class="trading-info">
                <div class="trading-pic1"></div>
                <div class="trading-info-text">
                  <div>We provide one stop service for supply of all types of construction equipment and materials to satisfy the whole construction process requirement</div>
                  <div>Our products procurement cover the entire construction field from accommodation units, office units, electrical tools, air tools, scaffoldings, consumables, MRO for the life circle of the projects.</div>
                </div>
              </div>
              <div class="trading-pic-group">
                <div class="left-pic">
                  <div class="trading-pic2"></div>
                  <div class="trading-pic3"></div>
                </div>
                <div class="trading-pic4"></div>
              </div>
            </div>
          </div>
        </section>
        <FooterView />
      </div>
    </div>
  </BaseView>
</template>

<script>
import BaseView from '@/components/BaseView.vue'
import HeaderView from '@/components/HeaderView.vue'
import FooterView from '@/components/FooterView.vue'
import utils from '../utils/util'
const { getQueryString } = utils

export default {
  name: '',
  props: {

  },
  components: {
    BaseView,
    HeaderView,
    FooterView
  },
  data () {
    return {
      navText: 'Core Business',
      activeIndex: 99,
      businessArr: [{
        id: 1,
        text: 'Project Procurement & Management'
      }, {
        id: 2,
        text: 'Supply-chain Management'
      }, {
        id: 3,
        text: 'Commodity Trading'
      }],
      procurementArr: [{
        id: 11,
        text: 'Modularization, fabrication and deliver for marine engineering energy, mining, municipal Engineering and infrastructure industry. '
      }, {
        id:12,
        text: 'Raw materials supply for power station, chemical plant.'
      }, {
        id: 13,
        text: 'Tools and equipment for construction engineering project.'
      }, {
        id: 14,
        text: 'Precast, curtain all, purling and ceramic and facade etc.'
      }, {
        id: 15,
        text: 'Carbon steel and stainless steel pipe supply for oil field and refinery.'
      }],

      supplyArr: [{
        id: 21,
        text: 'Supplier evaluation and factory assessment'
      }, {
        id:22,
        text: 'Contract estimation and negotiation'
      }, {
        id: 23,
        text: 'Procurement'
      }, {
        id: 24,
        text: 'Engineering and fabrication management'
      }, {
        id: 25,
        text: 'Project quality control'
      }, {
        id: 26,
        text: 'Expediting'
      }, {
        id: 27,
        text: 'Customer clearance and shipping'
      }],

      tradingArr: [{
        id: 31,
        text: 'CAPEX-Capital Expenditure'
      }, {
        id: 32,
        text: 'MRO, RAW Materials consumables'
      }, {
        id: 33,
        text: 'Construction material & Equipment'
      }, {
        id: 34,
        text: 'Fast moving goods & Office consumable'
      }, {
        id: 35,
        text: 'HSE tools, equipment and work wear.'
      }],

      chainArr: [{
        id: 61,
        imgUrl: require('../assets/spsc/coreBusiness/chain1.png'),
        text: 'Supplier Evaluation',
        describe: 'Database for qualified suppliers, monitoring of supplier’s previous performances, production capacity and available shop space, labor resources and China specific information. Provide supplier surveillance and audit their safety, quality and management systems, contract performance capability.'
      }, {
        id: 62,
        imgUrl: require('../assets/spsc/coreBusiness/chain2.png'),
        text: 'Commercial Negotiation',
        describe:'Win-win strategy for both customer and supplier balancing price, reliable quality, appropriate lead time, and lower risks.'
      }, {
        id: 63,
        imgUrl: require('../assets/spsc/coreBusiness/chain3.png'),
        text: 'Project Management',
        describe:'Win-win strategy for both customer and supplier balancing price, reliable quality, appropriate lead time, and lower risks.'
      }, {
        id: 64,
        imgUrl: require('../assets/spsc/coreBusiness/chain4.png'),
        text: 'Quality Assurance',
        describe: 'Experienced QA team and access to qualified inspectors are arranged on each project to ensure quality conformity and safety adherence are achieved.'
      }, {
        id: 65,
        imgUrl: require('../assets/spsc/coreBusiness/chain5.png'),
        text: 'Progress Management',
        describe: 'Experienced expediting team to monitor project progress and performance, and negotiate solutions as necessary.'
      },  {
        id: 66,
        imgUrl: require('../assets/spsc/coreBusiness/chain6.png'),
        text: 'Logistics & Shipping',
        describe: 'Logistics strategy designed according to product and schedule requirements. Sino Pacific Supply Chain Co., Ltd has strategic partnership with various shipping companies such as the production feature, Strategy partnership with shipping companies such as AAL and Spliethoff.'
      }],

    }
  },
  methods: {
    handleBusiness(item, index) {
      // this.navText = item.text
      this.activeIndex = index
    },
    changeBusinessContent (activeIndex) {
      this.activeIndex = activeIndex
    },
    goGoalPage( pathName) {
      this.$router.replace({ path: pathName})

      if (pathName === '/coreBusiness') {
        this.activeIndex = 99
      }
    }
  },
  created () {
    const curIndex = getQueryString('activeIndex')
    // console.log('====curIndex', curIndex, curIndex == 0, curIndex === 0, typeof curIndex)
    this.activeIndex = curIndex ? parseInt(curIndex): 99
  }
}
</script>
<style scoped lang="scss">

.index-container {
  background: #FFFFFF;
  width: 100%;
}

.index-container-supply {
  background: #F6F6F6;
  width: 100%;
}
.index-panel {
  width: 100%;
  min-width: 1200px;
} 

.nav-panel {
  width: 100%;
  height: 100%;
}

.navImg {
  width: 100%;
  height: auto;
  margin-top: -80px;
}

.nav-section {
  width: 1200px;
  margin: 40px auto 60px auto;
}

.nav-info {
  display: flex;
  justify-content: space-between;
  justify-items: center;
}

.nav-main-text, .nav-sub-text {
  font-size: 14px;
  color: #333333;
  cursor: pointer;
}

.nav-arrow {
  margin: 0 10px;
}

.nav-line {
  width: 100%;
  height: 1px;
  background: #D8D8D8;
  margin-top: 16px;
}

.business-group {
  width: 600px;
  display: flex;
  justify-content: space-between;
}

.business-item {
  position: relative;
}

.business-text {
  font-size: 14px;
  color: #333333;
  line-height: 24px;
  cursor: pointer;
}

.active-line {
  position: absolute;
  bottom: -16px;
  width: 100%;
  height: 3px;
  background: #0281C1;
}

.content-panel {
  width: 1200px;
  margin: 0 auto 80px auto;
}

.business-content {
  width: 100%;
}

.procurement-group {
  width: 100%;
  height: 330px;
  display: flex;
}

.procurement-left-part {
  width: 320px;
  height: 330px;
  background: #0281C1;
}

.business-title {
  font-size: 24px;
  font-weight: bold;
  color: #FFFFFF;
  line-height: 36px;
  margin: 60px 0 0 40px;
}

.moer-btn-project {
  width: 80px;
  height: 38px;
  background: #FFFFFF;
  border-radius: 19px;
  margin: 40px 0 0 40px;
  font-size: 20px;
  color: #0281C1;
  font-weight: 500;
  line-height: 38px;
  cursor: pointer;
  text-align: center;
}

.moer-btn-supply {
  width: 80px;
  height: 38px;
  background: #FFFFFF;
  border-radius: 19px;
  margin: 40px 0 0 40px;
  font-size: 20px;
  color: #223093;
  font-weight: 500;
  line-height: 38px;
  cursor: pointer;
  text-align: center;
}

.moer-btn {
  margin: 40px 0 0 40px;
  font-size: 20px;
  color: #FFFFFF;
  line-height: 20px;
  cursor: pointer;
}

.procurement-right-part {
  width: 800px;
  height: 260px;
  padding: 40px 40px 30px 40px;
  background:rgba(2,129,193,0.15);
  
}

.procurement-item {
  display: flex;
  justify-items: center;
  line-height: 28px;
  margin-bottom: 20px;
}

.circle-dot {
  width: 8px;
  height: 8px;
  border-radius: 8px;
  background: #0281C1;
  margin-top: 10px;
}

.procurement-text {
  font-size: 16px;
  color: #0281C1;
  margin-left: 8px;
}

.supply-group {
  width: 100%;
  height: 390px;
  display: flex;
  margin-top: 32px;
}

.supply-left-part {
  width: 320px;
  height: 390px;
  background: #223093;
}

.supply-right-part {
  width: 800px;
  height: 320px;
  padding: 40px 40px 30px 40px;
  background:rgba(34,48,147,0.15);
}

.supply-item {
  display: flex;
  justify-items: center;
  line-height: 28px;
  margin-bottom: 20px;
}

.supply-circle-dot {
  width: 8px;
  height: 8px;
  border-radius: 8px;
  background: #223093;
  margin-top: 10px;
}

.supply-text {
  font-size: 16px;
  color: #223093;
  margin-left: 8px;
}

.trading-group {
  width: 100%;
  height: 300px;
  display: flex;
  margin-top: 32px;
}

.trading-left-part {
  width: 320px;
  height: 300px;
  background: #D8D8D8;
}

.trading-title {
  font-size: 24px;
  font-weight: bold;
  color: #333333;
  line-height: 36px;
  margin: 80px 0 0 40px;
}

.trading-moer-btn {
  width: 80px;
  height: 38px;
  background: #FFFFFF;
  border-radius: 19px;
  margin: 40px 0 0 40px;
  font-size: 20px;
  color: #333333;
  font-weight: 500;
  line-height: 38px;
  cursor: pointer;
  text-align: center;
}

.trading-right-part {
  width: 800px;
  height: 230px;
  padding: 40px 40px 30px 40px;
  background:rgba(216,216,216,0.15);
}

.trading-item {
  display: flex;
  justify-items: center;
  line-height: 28px;
  margin-bottom: 20px;
}

.trading-circle-dot {
  width: 8px;
  height: 8px;
  border-radius: 8px;
  background: #333333;
  margin-top: 10px;
}

.trading-text {
  font-size: 16px;
  color: #333333;
  margin-left: 8px;
}

/** Project Procurement */

.content-title {
  width: 1180px;
  height: 48px;
  background: #0281C1;
  font-size: 20px;
  font-weight: bold;
  color: #FFFFFF;
  line-height: 48px;
  padding-left: 20px;
  margin-bottom: 40px;
}

.project-pic1 {
  width: 1200px;
  height: 480px;
  background: url('../assets/spsc/coreBusiness/project1.png') no-repeat;
  background-size: contain;
}

.project-pic-group {
  display: flex;
  justify-content: space-between;
  margin: 20px 0 60px 0;
}

.project-pic2{
  width: 700px;
  height: 360px;
  background: url('../assets/spsc/coreBusiness/project2.png') no-repeat;
  background-size: contain;
}

.project-pic3 {
  width: 480px;
  height: 360px;
  background: url('../assets/spsc/coreBusiness/project3.png') no-repeat;
  background-size: contain;
}

.project-intro {
  font-size: 14px;
  color: #333333;
  line-height: 24px;
  margin-bottom: 60px;
}

.project-intro div {
  margin-bottom: 10px;
}

.project-pic4 {
  width: 1200px;
  height: 480px;
  background: url('../assets/spsc/coreBusiness/project4.png') no-repeat;
  background-size: contain;
}

.project-pic-group1 {
  display: flex;
  justify-content: space-between;
  margin: 20px 0 100px 0;
}

.project-pic5{
  width: 700px;
  height: 360px;
  background: url('../assets/spsc/coreBusiness/project5.png') no-repeat;
  background-size: contain;
}

.project-pic6 {
  width: 480px;
  height: 360px;
  background: url('../assets/spsc/coreBusiness/project6.png') no-repeat;
  background-size: contain;
}

.management-group {
  display: flex;
  justify-content: space-between;
  margin-top: 5px;
  margin-bottom: 25px;
}

.management-info {
  font-size: 14px;
  color: #333333;
  line-height: 24px;
}

.management-words {
  font-size: 14px;
  color: #333333;
  line-height: 40px;
  margin-top: 10px;
  margin-bottom: 10px;
}

.project-pic7 {
  width: 590px;
  height: 453px;
  background: url('../assets/spsc/coreBusiness/project7.png') no-repeat;
  background-size: contain;
}

.project-pic8 {
  width: 590px;
  height: 440px;
  background: url('../assets/spsc/coreBusiness/project8.png') no-repeat;
  background-size: contain;
}

.project-pic9 {
  width: 590px;
  height: 440px;
  background: url('../assets/spsc/coreBusiness/project9.png') no-repeat;
  background-size: contain;
}


/** Supply-chain Management */

.supply-chain-section {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.chain-item {
  width: 510px;
  height: 304px;
  background: #FFFFFF;
  padding: 36px 30px 0 40px;
  margin-bottom: 40px;
}

.chain-img {
  width: 80px;
  height: 80px;
}

.chain-text {
  font-size: 20px;
  font-weight: bold;
  color: #111111;
  line-height: 20px;
  margin-top: 24px;
}

.chain-describe {
  font-size: 14px;
  color: #333333;
  line-height: 24px;
  margin-top: 20px;
}



/** Commodity Trading */

.trading-pic1 {
  width: 1200px;
  height: 500px;
  background: url('../assets/spsc/coreBusiness/trading-pic1.png') no-repeat;
  background-size: contain;
}

.trading-pic2 {
  width: 464px;
  height: 244px;
  background: url('../assets/spsc/coreBusiness/trading-pic2.png') no-repeat;
  background-size: contain;
}

.trading-pic3 {
  width: 464px;
  height: 186px;
  background: url('../assets/spsc/coreBusiness/trading-pic3.png') no-repeat;
  background-size: contain;
  margin-top: 20px;
}

.trading-pic4 {
  width: 716px;
  height: 450px;
  background: url('../assets/spsc/coreBusiness/trading-pic4.png') no-repeat;
  background-size: contain;
}

.trading-info-text {
  width: 1120px;
  height: 90px;
  padding: 40px 40px 30px 40px;
  background: #F6F6F6;
  font-size: 14px;
  color: #333333;
  line-height: 24px;
}

.trading-info-text div {
  margin-bottom: 10px;
}

.trading-pic-group {
  display: flex;
  justify-content: space-between;
  margin-top: 40px;
}

</style>